import { createElementVNode as _createElementVNode, vShow as _vShow, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, createStaticVNode as _createStaticVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../assets/xiaoniu-wechat.jpg';
const _withScopeId = n => (_pushScopeId("data-v-6b08a0e0"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "footer"
};
const _hoisted_2 = {
  class: "footer-content"
};
const _hoisted_3 = {
  class: "footer-left"
};
const _hoisted_4 = {
  class: "social-links"
};
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<a href=\"https://github.com/xiaoniu667\" target=\"_blank\" class=\"social-link\" title=\"GitHub\" data-v-6b08a0e0><i class=\"fab fa-github\" data-v-6b08a0e0></i></a><a href=\"https://space.bilibili.com/397376094?spm_id_from=333.1007.0.0\" target=\"_blank\" class=\"social-link\" title=\"哔哩哔哩\" data-v-6b08a0e0><i class=\"fab fa-bilibili\" data-v-6b08a0e0></i></a><a href=\"https://www.douyin.com/user/self/search/%E5%B0%8F%E7%89%9B%E7%BC%96%E7%A8%8B?type=general\" target=\"_blank\" class=\"social-link\" title=\"抖音\" data-v-6b08a0e0><i class=\"fab fa-tiktok\" data-v-6b08a0e0></i></a>", 3);
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fab fa-weixin"
}, null, -1));
const _hoisted_9 = [_hoisted_8];
const _hoisted_10 = /*#__PURE__*/_createStaticVNode("<div class=\"footer-center\" data-v-6b08a0e0><div class=\"copyright\" data-v-6b08a0e0><i class=\"far fa-copyright\" data-v-6b08a0e0></i><span data-v-6b08a0e0>2024-2025 小牛知识分享</span><span class=\"divider\" data-v-6b08a0e0>|</span><span data-v-6b08a0e0>All Rights Reserved</span><span class=\"divider\" data-v-6b08a0e0>|</span><span data-v-6b08a0e0>陕ICP备2022000311号</span></div></div>", 1);
import { ref, reactive } from 'vue';
export default {
  __name: 'GlobalFooter',
  setup(__props) {
    const showQrCode = ref(false);
    const qrCodePosition = reactive({
      left: '0px',
      top: '0px'
    });
    const updateQrPosition = event => {
      const rect = event.target.getBoundingClientRect();
      qrCodePosition.left = rect.left + rect.width / 2 + 'px';
      qrCodePosition.top = rect.top - 10 + 'px';
    };
    const showQr = event => {
      updateQrPosition(event);
      showQrCode.value = true;
    };
    const hideQr = () => {
      showQrCode.value = false;
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("footer", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_hoisted_5, _createElementVNode("a", {
        class: "social-link wechat-container",
        title: "微信",
        onMouseenter: showQr,
        onMouseleave: hideQr
      }, _hoisted_9, 32)])]), _hoisted_10]), (_openBlock(), _createBlock(_Teleport, {
        to: "body"
      }, [_withDirectives(_createElementVNode("img", {
        class: "wechat-qr",
        src: _imports_0,
        alt: "微信二维码",
        style: _normalizeStyle(qrCodePosition)
      }, null, 4), [[_vShow, showQrCode.value]])]))]);
    };
  }
};